var initMiewParceiros = function () {
    if ($('.parceiros-slick').length > 0) {
        $('.parceiros-slick').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 5,
            slidesPerRow: 3, 
            arrows: false,
            cursors: false,
            infinite: false,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        rows: 5,
                        slidesPerRow: 2,
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        rows: 5,
                        slidesPerRow: 5,
                    }
                },
                {
                    breakpoint: 760,
                    settings: {
                        rows: 5,
                        slidesPerRow: 4,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        rows: 5,
                        slidesPerRow: 3,
                    }
                }
            ]
        });
    }
}